import { FormStatusType, formStatusTypeMap } from './formStatusType'
import { Observable, ReplaySubject } from 'rxjs'
import { coerceToArray } from '../../services/utils'
import { EventEmitter } from '@angular/core'

export class FormStatus {
  text: string = ''
  explanationText: string = ''
  color: string
  TAG: string = 'FormStatus'

  protected status: FormStatusType
  protected status$$ = new ReplaySubject<this>(1)

  status$: Observable<this> = this.status$$.asObservable()
  lastSavedTimestamp: number

  constructor(
    startingStatus: FormStatusType = FormStatusType.NO_CHANGES,
    protected statusEmitter?: EventEmitter<FormStatusType>,
  ) {
    console.debug(this.TAG, 'constructor', this)
    this.setStatus(startingStatus)
  }

  private setStatus(statusType: FormStatusType, message = '') {
    const mapping = this.getMappingFromType(statusType)

    this.text = mapping.text
    this.explanationText = message ? ': ' + message : ''
    this.color = mapping.color

    this.status = statusType
    console.log(`formStatus#setStatus to ${this.text}`)
    this.status$$.next(this)
    this.statusEmitter?.emit(statusType)
  }

  get statusType() {
    return this.status
  }

  setValidWithUnsavedChanges() {
    this.setStatus(FormStatusType.VALID_UNSAVED_CHANGES)
  }

  setSaving() {
    console.debug(this.TAG, 'setSaving')
    this.setStatus(FormStatusType.SAVING)
  }

  setInvalid(recordHasId: boolean, requiredLabels: string[] = []) {
    console.debug(this.TAG, 'setInvalid', recordHasId)
    const missingFields = requiredLabels.join(', ')
    missingFields.length !== 0
      ? this.setStatus(FormStatusType.ERROR_MISSING_FIELD, missingFields)
      : this.setStatus(FormStatusType.ERROR_VALIDATION)
  }

  setSaved() {
    console.debug(this.TAG, 'setSaved')
    this.setStatus(FormStatusType.SAVED)
    this.lastSavedTimestamp = Date.now()
  }

  setError(message?: string) {
    console.debug(this.TAG, 'setError')
    this.setStatus(FormStatusType.ERROR_WHILE_SAVING, message)
  }

  isSaved() {
    return this.is(FormStatusType.SAVED)
  }

  isSaving() {
    return this.is(FormStatusType.SAVING)
  }

  isNotOk() {
    return this.is([
      FormStatusType.VALIDATING,
      FormStatusType.ERROR_WHILE_SAVING,
      FormStatusType.INVALID,
      FormStatusType.ERROR_MISSING_FIELD,
      FormStatusType.ERROR_VALIDATION,
    ])
  }

  isSettled() {
    return this.is([FormStatusType.SAVED, FormStatusType.NO_CHANGES])
  }

  is(statusType: FormStatusType | FormStatusType[]) {
    return coerceToArray(statusType).includes(this.status)
  }

  getObservable() {
    return this.status$
  }

  private getMappingFromType(statusType: FormStatusType) {
    return formStatusTypeMap.find((m) => m.type === statusType)
  }

  setValidating() {
    this.setStatus(FormStatusType.VALIDATING)
  }

  reset() {
    this.setStatus(FormStatusType.NO_CHANGES)
  }
}
